/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { InspectionStatusViewModel } from './inspectionStatusViewModel';
import { PunchViewModel } from './punchViewModel';

export interface InspectionWalkViewModel { 
    id?: number;
    code?: string;
    description?: string;
    track?: string;
    startDate?: Date;
    closeDate?: Date;
    punch?: Array<PunchViewModel>;
    inspectionStatus?: InspectionStatusViewModel;
    fromImport?: boolean;
}